import * as React from "react";
import { PFTResults, StudyRelevantParameters } from '../Shared/PFTAPITypes';
import { LocalizedDateTime, DateTimeAccuracy } from '../../misc/components/LocalizedDateTime';
import { PFTResultParameters } from '../Shared/PFTResultsParameters';
import { FixedCommentsSelectors } from '../Shared/FixedCommentsSelectors';
import { FixedCommentsState, ToggleSessionFixedCommentsVisibilityAction, ToggleTestFixedCommentsVisibilityAction, PageValidatedAction, LoadAnalysisSetOverreadAction, ToggleSessionFixedCommentCheckedAction, ToggleTestFixedCommentCheckedAction } from "../Shared/UseFixedComments";
import { SelectedTestCommentsCount, SelectedSessionCommentsCount } from "../Shared/Selectors/FixedCommentSelectors";
import { CommentModals } from "../Shared/CommentsModals";
import { AcceptabilityState, ToggleTestAcceptabilityAction } from '../Shared/UseAcceptability';
import RepeatabilityTable from "../Shared/RepeatabilityTable";
import { DlcoTestAcceptabilityTable } from "./DlcoTestAcceptabilityTable";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { NextGenFixedCommentSelectors } from "../Spirometry/Testing/NextGenFixedCommentSelectors";
import { DlcoSession } from "webportalclient";
import { NextGenFixedCommentsState } from "../Spirometry/Testing/UseNextGenFixedComments";
import { OverreadingResultsComments } from "../Shared/OverreadingResultsComments";
import { ResultsContext } from "../Spirometry/UseResultsContext";

export interface DlcoResultsTableProps {
    isViewOnly: boolean;
    isSiteAnalysisSet: boolean;
    resultData: PFTResults;
    session: DlcoSession;
    fixedCommentsStateOverreading: NextGenFixedCommentsState;
    fixedCommentsDispatchOverreading;
    acceptabilityState: AcceptabilityState;
    acceptabilityDispatch;
    shouldValidateFixedComments: boolean;
}

export const DlcoResultsTable = ({ isViewOnly, isSiteAnalysisSet, resultData, session, fixedCommentsStateOverreading, fixedCommentsDispatchOverreading, shouldValidateFixedComments, acceptabilityState, acceptabilityDispatch }: DlcoResultsTableProps) => {
    return (
        <>
            <ResultsContext.Provider value={{ showBestValues: true, showPredictedValues: false, showPercentagePredicted: false, showReversibilityBaseValue: false, showReversibilityAbsoluteChange: false, showReversibilityPercentageChange: false }}>
                <table id="DlcoResultsTable" className="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            {
                                resultData.TestResults.sort((a, b) => a.TestNumber - b.TestNumber).map(t =>
                                    <th key={`TestHeader${t.TestId}`} style={{ color: "#000" }}>{t.TestNumber}</th>
                                )}
                            <th>Best</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Time</td>
                            {
                                resultData.TestResults.sort((a, b) => a.TestNumber - b.TestNumber).map(t =>
                                    <td key={`TestDateTime${t.TestId}`}>
                                        <LocalizedDateTime time={t.TestDateTime} accuracy={DateTimeAccuracy.Second} />
                                    </td>
                                )}
                            <td></td>
                        </tr>
                        <PFTResultParameters 
                            isLoading={acceptabilityState.loadingBestValues} 
                            results={resultData} 
                            compareWithTestParameters={true} 
                        />
                        <RepeatabilityTable isLoading={acceptabilityState.loadingBestValues} results={acceptabilityState.spirometryResults} />
                        <DlcoTestAcceptabilityTable
                            isViewOnly={isViewOnly}
                            displayTechnicianAcceptability={!isSiteAnalysisSet}
                            testResults={acceptabilityState.spirometryResults.TestResults}
                            onAcceptabilityChange={(id, checked) => acceptabilityDispatch(ToggleTestAcceptabilityAction.create(id, checked))}
                        />
                        <OverreadingResultsComments
                            viewOnly={isViewOnly}
                            session={session}
                            showTechnician={false}
                            fixedCommentsDispatchOverreading={fixedCommentsDispatchOverreading}
                            fixedCommentsStateOverreading={fixedCommentsStateOverreading}
                        />
                    </tbody>
                </table>
            </ResultsContext.Provider>
        </>
    );
}
